import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Banknote, Leaf, Landmark, Sparkles, Sun, ArrowRight } from "lucide-react";
import SectionLabel from "@/components/layout/SectionLabel";

const OPTIONS = [
  { icon: Leaf, t: "Green loans", b: "Specialist lenders for energy-efficient home upgrades." },
  { icon: Banknote, t: "Home improvement finance", b: "Personal loan products from third-party providers." },
  { icon: Landmark, t: "Bank finance", b: "Top-up your mortgage or use your bank's renovation lending." },
  { icon: Sparkles, t: "Interest-free offers", b: "If/when available, time-limited deals with partner providers." },
  { icon: Sun, t: "Solar & battery finance", b: "Future packaged finance for full home electrification." },
];

export default function Finance() {
  return (
    <div className="bg-white">
      <section className="border-b border-[#E2E8F0]">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 py-20">
          <SectionLabel>Finance options</SectionLabel>
          <h1 className="font-heading mt-4 text-4xl sm:text-6xl font-bold tracking-tight text-[#0B132B]">
            Finance Options for Your Hot Water Upgrade
          </h1>
          <p className="mt-5 text-lg text-[#475569] max-w-2xl">
            AeroMax Energy is exploring finance pathways to help households upgrade sooner. Options may include green loans, home improvement finance, bank lending or payment partner solutions.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6 sm:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
            {OPTIONS.map((o, i) => (
              <Card key={i} className="rounded-2xl p-7 border-[#E2E8F0] bg-white">
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[#10B981]/10 text-[#10B981] mb-4">
                  <o.icon className="h-5 w-5" />
                </span>
                <p className="font-heading text-xl font-semibold text-[#0B132B]">{o.t}</p>
                <p className="text-sm text-[#475569] mt-1">{o.b}</p>
              </Card>
            ))}
          </div>
          <Card className="mt-10 rounded-2xl p-6 border-[#E2E8F0] bg-[#F8FAFC]">
            <p className="text-xs text-[#475569]">
              <strong className="text-[#0B132B]">Disclaimer:</strong> AeroMax Energy does not provide financial advice or credit approval. Finance availability, eligibility and approval are subject to the finance provider's terms.
            </p>
          </Card>
          <div className="text-center mt-10">
            <Link to="/contact" data-testid="finance-cta" className="inline-flex items-center gap-2 rounded-full bg-[#10B981] hover:bg-[#059669] text-white px-7 py-4 font-semibold">
              Ask About Finance Options <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
